import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { TypingActions } from './typing.actions';
import { MessagesActions } from '../messages/messages.actions';
import { MainComponentActions } from '../main.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { TypingEffects } from './typing.effects';
import { MessageType } from '../../types/enum';

export const initialState: Readonly<Typing> = {
  isVaOrAgentTyping: false,
  isUserTyping: false,
};

export const typingFeature = createFeature({
  name: 'typing',
  reducer: createReducer(
    initialState,
    on(
      TypingActions.setVaTyping,
      TypingActions.setAgentTyping,
      (state, { value }) => {
        return { ...state, isVaOrAgentTyping: value };
      }
    ),
    on(TypingActions.setUserTyping, (state, { value }) => {
      return { ...state, isUserTyping: value };
    }),
    on(
      MainComponentActions.mainComponentLoaded,
      MessagesActions.dialogApiFailed,
      (state) => {
        return { ...state, isVaOrAgentTyping: false, isUserTyping: false };
      }
    ),
    on(MessagesActions.addNewMessages, (state, { messages }) => {
      if (messages?.length && messages[0].messageType !== MessageType.USER) {
        return { ...state, isVaOrAgentTyping: false, isUserTyping: false };
      }
      return state;
    }),
    on(
      MessagesActions.callDialogApi,
      MessagesActions.addMessagesWithDelay,
      (state) => {
        return { ...state, isVaOrAgentTyping: true };
      }
    )
  ),
});

export const {
  selectTypingState,
  selectIsUserTyping,
  selectIsVaOrAgentTyping,
} = typingFeature;

export function provideTypingFeature() {
  return makeEnvironmentProviders([
    provideState(typingFeature),
    provideEffects(TypingEffects),
  ]);
}
